<form (ngSubmit)="saveSettings()" [formGroup]="brandingForm" class="branding-form">
    <!-- Logo Upload -->
    <div class="form-group mb-4">
        <label>Company Logo</label>
        <div *ngIf="merchant?.logoUrl" class="logo-preview">
            <img [src]="merchant!.logoUrl" alt="Current Logo" class="logo-image" />
            <small class="logo-caption">Current logo</small>
            <button type="button" class="btn-remove-logo" (click)="removeLogo()">
                <i class="fa-solid fa-trash me-1"></i>Remove Logo
            </button>
        </div>
        <input type="file" class="form-control" (change)="onLogoSelected($event)" accept="image/*" />
        <small class="form-text">Upload a new logo image (PNG, JPG, SVG)</small>
    </div>

    <!-- Custom Heading -->
    <div class="form-group mb-4">
        <label for="customHeading">Custom Heading</label>
        <input type="text" class="form-control" id="customHeading" formControlName="customHeading" placeholder="Welcome to Our Parking" />
        <small class="form-text">Custom heading text for your parking site (leave empty to use company name)</small>
    </div>

    <!-- Actions -->
    <div class="form-actions">
        <button type="button" class="btn-reset" (click)="resetForm()">Reset</button>
        <button type="submit" class="btn-save" [disabled]="loading || brandingForm.invalid">
            <i *ngIf="loading" class="fa fa-circle-notch fa-spin me-2"></i>
            Save Branding Settings
        </button>
    </div>
</form>
